<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" :content="id ? '编辑账目类型' : '添加账目类型'"></el-page-header>
		<el-form label-position="right" :rules="rules" ref="ruleForm" :model="item" label-width="auto">
			<el-form-item label="账目类型">
				<el-input v-model="item.name" placeholder="请输入账目类型"></el-input>
			</el-form-item>
			<el-form-item label="排序">
				<el-input v-model="item.orders" placeholder="请输入排序"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button size="big" type="primary" @click="checkSubmit">保存</el-button>
			</el-form-item>
			<el-form-item>
				<el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
					<span>您确认保存嘛</span>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="submit">确 定</el-button>
					</span>
				</el-dialog>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				item: {},
				isLoad: false,
				id: this.$route.query.id,
				dialogVisible: false,
				rules: {}
			}
		},
		created() {
			this.loadData()
		},
		methods: {
			loadData: function () {
			    if (this.isLoad) {
			        return
			    }
			    this.isLoad = !this.isLoad
			    this.axios.post('/admin/financeType/detail', {
			        id: this.id
			    }).then(res => {
			        this.isLoad = !this.isLoad
			        // item是基础信息
			        this.item = res.data.detail
			    }).catch(() => {
			        this.isLoad = !this.isLoad
			    })
			},
			// 后退一步
			goBack() {
				this.$router.back(-1)
			},
			checkSubmit() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.dialogVisible = true
					} else {
						this.$message.warning("请检查表单信息是否正确");
						return false;
					}
				});
			},
			// 提交
			submit() {
				if (this.isLoad) {
					return
				}
				let url = ''
				if (this.id) {
					url = '/admin/financeType/edit'
					this.item.id = this.id
				} else {
					url = '/admin/financeType/add'
				}
				this.axios.post(url, this.item)
						.then(() => {
							this.isLoad = !this.isLoad
							this.$message.success({
								message: '保存成功'
							});
							this.goBack()
						})
						.catch(() => {
							this.isLoad = !this.isLoad
						})
			}
		}
	}
</script>
<style scoped>
</style>
